<template>
  <v-col>
    <template v-if="media.length">
      <div>
        <ul style="margin: 0; padding: 0">
          <li
            v-for="(image, index) in media"
            :key="index"
            style="display: inline-block; margin: 0 5px 5px 0"
          >
            <img
              :src="image.thumb"
              style="height: 150px; width: 150px; cursor: pointer"
              @click="openGallery(index)"
            />
          </li>
        </ul>

        <LightBox
          ref="lightbox"
          :media="media"
          :show-caption="true"
          :show-light-box="false"
        />
      </div>
    </template>
    <template v-else>
      <v-alert type="info">
        Recored not found !
      </v-alert>
    </template>
  </v-col>
</template>

<script>
import LightBox from "./components/LightBox";

export default {
  components: {
    LightBox,
  },

  data() {
    return {
      list: [],
    };
  },
  computed: {
    media() {
      var data = [];
      this.$data.list.map((item) => {
        if (item.type) {
          data.push({
            id: item.id,
            thumb: "/storage/default_img/play.jpg",
            sources: [
              {
                src: "/storage/" + item.image,
                type: "video/mp4",
              },
            ],
            type: "video",
            caption: item.title,
            width: 800,
            height: 600,
          });
        } else {
          data.push({
            id: item.id,
            thumb: "/storage/" + item.image,
            src: "/storage/" + item.image,
            caption: item.title,
          });
        }
      });
      return data;
    },
  },
  mounted() {
    window.axios.get("/get-gallery-items").then((response) => {
      this.$data.list = response.data.list;
    });
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>
